import React from 'react';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';

interface TransactionSummaryCardProps {
    firstFieldName: string;
    walletNo: string;
    value: string | number;
    commissionValue: number;
    totalValue: number;
    currencyLabel?: string;
    formatMoney: (value: number) => string;
}

const TransactionSummaryCard: React.FC<TransactionSummaryCardProps> = ({
    firstFieldName,
    walletNo,
    value,
    commissionValue,
    totalValue,
    currencyLabel = '₺',
    formatMoney
}) => (
    <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        textAlign: 'center',
        mt: 2
    }}>
        <Card
            elevation={0}
            sx={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                borderRadius: 3,
                p: { xs: 2, sm: 3 },
                overflow: 'hidden'
            }}
        >
            <CardContent sx={{ pb: '16px !important', px: { xs: '16px !important', sm: '24px !important' } }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                    İşlem Özeti
                </Typography>
                <Grid container spacing={2} sx={{ textAlign: 'left' }}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: 2,
                            p: 2,
                            backdropFilter: 'blur(10px)',
                            overflow: 'hidden',
                            minHeight: '80px'
                        }}>
                            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
                                {firstFieldName}
                            </Typography>
                            <Typography 
                                variant="h6" 
                                sx={{ 
                                    fontWeight: 600,
                                    wordBreak: 'break-all',
                                    overflowWrap: 'break-word',
                                    fontSize: { xs: '0.875rem', sm: '1rem' },
                                    lineHeight: 1.4
                                }}
                            >
                                {walletNo}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: 2,
                            p: 2,
                            backdropFilter: 'blur(10px)',
                            overflow: 'hidden',
                            minHeight: '80px'
                        }}>
                            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
                                Gönderilecek Tutar
                            </Typography>
                            <Typography 
                                variant="h6" 
                                sx={{ 
                                    fontWeight: 600,
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    fontSize: { xs: '0.875rem', sm: '1rem' },
                                    lineHeight: 1.4
                                }}
                            >
                                {value} {currencyLabel}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: 2,
                            p: 2,
                            backdropFilter: 'blur(10px)',
                            overflow: 'hidden',
                            minHeight: '80px'
                        }}>
                            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
                                Komisyon Tutarı
                            </Typography>
                            <Typography 
                                variant="h6" 
                                sx={{ 
                                    fontWeight: 600,
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    fontSize: { xs: '0.875rem', sm: '1rem' },
                                    lineHeight: 1.4
                                }}
                            >
                                {formatMoney(commissionValue)}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{
                            background: 'rgba(255,255,255,0.2)',
                            borderRadius: 2,
                            p: 2,
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255,255,255,0.3)',
                            overflow: 'hidden',
                            minHeight: '80px'
                        }}>
                            <Typography variant="body2" sx={{ opacity: 0.9, mb: 1 }}>
                                Toplam Tutar
                            </Typography>
                            <Typography 
                                variant="h5" 
                                sx={{ 
                                    fontWeight: 700,
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    fontSize: { xs: '1rem', sm: '1.25rem' },
                                    lineHeight: 1.4
                                }}
                            >
                                {formatMoney(totalValue)}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    </Box>
);

export default TransactionSummaryCard;
